import type { MailboxCategory } from '@/types';

/** `messages` namespace key per mailbox category (#3736). */
export const mailboxCategoryLabelKey: Record<MailboxCategory, string> = {
  spam: 'emailCategorySpam',
  auto_reply: 'emailCategoryAutoReply',
  bulk: 'emailCategoryBulk',
};
